import { render, staticRenderFns } from "./zhzw.vue?vue&type=template&id=853f7dfe&scoped=true&"
import script from "./zhzw.vue?vue&type=script&lang=js&"
export * from "./zhzw.vue?vue&type=script&lang=js&"
import style0 from "./zhzw.vue?vue&type=style&index=0&id=853f7dfe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853f7dfe",
  null
  
)

export default component.exports